export { default as Spinner } from "./Spinner.svelte";
